import { Container, CssBaseline, Typography } from "@mui/material";
import type { History } from "../core/history";

type ErrorPageProps = {
  error: Error;
  history: History;
};

function ErrorPage(props: ErrorPageProps): JSX.Element {
  const { error } = props;

  return (
    <Container sx={{ marginTop: "43vh" }}>
      <CssBaseline />
      <Container maxWidth="sm">
        <Typography
          variant="h1"
          align="center"
          sx={{
            fontSize: "2em",
            fontWeight: 300,
            "& strong": {
              fontWeight: 400,
            },
          }}
        >
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
          <strong>Error {(error as any).status || 500}</strong>: {error.message}
        </Typography>
      </Container>
    </Container>
  );
}

export { ErrorPage, type ErrorPageProps };
